import * as Personnummer from 'personnummer';
export const personNumberFormatter = (ssn: string): string => {

  const formatted = Personnummer.default.parse(ssn).format(true);
  const first = formatted.substring(0, 8);
  const last = formatted.substring(8, formatted.length);
  return first + '-' + last;
};
